module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tile is-ancestor"
  }, [_c('div', {
    staticClass: "tile is-parent"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.adduser($event)
      }
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Edit File Info")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.name),
      expression: "file.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "name",
      "placeholder": "filename"
    },
    domProps: {
      "value": (_vm.file.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Tags")]), _vm._v(" "), _c('p', {
    staticClass: "control has-icon has-icon-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.tags),
      expression: "file.tags"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "seo tags",
      "value": "tags"
    },
    domProps: {
      "value": (_vm.file.tags)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.tags = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    on: {
      "click": _vm.updateFileInfo
    }
  }, [_vm._v("Submit")])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-61c42ffe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/FileEdit.vue
// module id = 158
// module chunks = 34